var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "-1 -1 14 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.25,
    d: "M1.42.625h10.113c.442 0 .8.358.8.8V20.58c0 .442-.358.8-.8.8H1.423c-.442 0-.8-.358-.8-.8V1.42c0-.21.084-.414.234-.563.15-.15.352-.233.563-.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M7.12 17.75c0 .35-.21.666-.532.8-.323.133-.695.06-.942-.188-.247-.247-.32-.62-.187-.942.132-.322.448-.533.797-.533.477 0 .864.387.864.864"
  }))));
};
export default SvgPhone;